import React, { useEffect } from 'react';
import moment from 'moment';
import Task from '../../Task/Task';
import cn from 'classnames';
import { getGridColumn, getGridRow } from '../utils';
import { containerIds } from '../../../constants/containerIds';
import { states } from '../../../constants/states';
import TaskWithPopover from '../../TaskWithPopover/TaskWithPopover';
import CellWithMoreBtn from './CellWithMoreBtn';
import { TASKS_CONTAINER } from '../../../constants/common';
import useCellClickHandlers from '../../../hooks/useCellClickHandlers';
import useMoreButtonClick from '../../../hooks/useMoreButtonClick';
import { useCalendarState } from '../../../context/CalendarContext';
import commonStyles from '../../../Calendar.module.scss';
import styles from '../CalendarGrid.module.scss';

const taskProps = (task, taskCount) => ({
  infoDirection: taskCount > 2 ? 'column' : 'row',
  hideWorkers: taskCount > 2,
  hideTimeInterval: taskCount > 4,
  inline: taskCount > 2,
  task,
  getPopupContainer: () => document.getElementById(containerIds.calendarGrid),
});

const MonthView = () => {
  const { calendarSheet, calendarData, state, localTask } = useCalendarState();

  const handleMoreButtonClick = useMoreButtonClick();

  const { handleMonthCellClick } = useCellClickHandlers();

  // scroll to top
  useEffect(() => {
    if (!localTask) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, []);

  return calendarData.map((item, index) => {
    const taskArray =
      localTask && item.day.isSame(moment(localTask.fromDate), 'day')
        ? [localTask, ...item.tasks]
        : item.tasks;

    const tasks = taskArray.filter((task) => task.visible);

    return (
      <CellWithMoreBtn
        key={index}
        data-element={TASKS_CONTAINER}
        day={item.day}
        taskCount={tasks.length}
        onMoreBtnClick={() => handleMoreButtonClick(item)}
        className={cn(styles.cellWrapper, {
          [styles.noCurrentMonthBackground]: !calendarSheet.isSame(
            item.day,
            'month'
          ),
          [styles.borderRight]: (index + 1) % 7 !== 0,
        })}
        style={{
          gridColumn: getGridColumn(index),
          gridRow: getGridRow(index),
        }}
        onClick={
          state === states.addTask
            ? (e) => handleMonthCellClick(e, index)
            : undefined
        }
      >
        {tasks?.slice(0, 6).map((task) => {
          return task.withPopover ? (
            <TaskWithPopover
              key={task.requestId}
              {...taskProps(task, tasks.length)}
            />
          ) : (
            <Task
              key={task.id}
              rootClassName={cn(commonStyles[`checkbox-${task.index}`], 'task')}
              {...taskProps(task, tasks.length)}
            />
          );
        })}
      </CellWithMoreBtn>
    );
  });
};

export default MonthView;
